<template>
    
    <div class="arrowsize" @click="getPreContent">
        <div class="half-circle">
            <span class="iconfont">&#xe626;</span>
        </div>
    </div>
    
</template>

<script>
    export default {
        name:'leftBack',
        methods:{
            getPreContent(){
                this.$emit("getPreContent");
            }
        }
    }
</script>

<style  scoped>
    @media screen and (max-width:768px){
        .arrowsize {
            position: absolute;
            top:0;
            bottom: 0;
            width: 20px;
            height: 40px;
            overflow: hidden;
            left:0px;
            margin:auto;
            z-index:99;
            cursor: pointer;
        }
        .arrowsize .half-circle {
            background-color: #d66567;
            width: 200%;
            height: 100%;
            border-radius: 50%;
            line-height: 40px;
            color: #fff;
            animation: colorchange 2s infinite;
            -webkit-animation: colorchange 2s infinite;
        }
         .arrowsize .half-circle .iconfont {
            margin-left: 2px;
            display: inline-block;
            font-size: 16px;
            transform: rotate(180deg);
            -ms-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            -webkit-transform: rotate(180deg);
            -o-transform: rotate(180deg);
        }
    }
    @media screen and (min-width:768px){
        .arrowsize {
            position: absolute;
            top:0;
            bottom: 0;
            width: 45px;
            height: 90px;
            overflow: hidden;
            left:20px;
            margin:auto;
            z-index:99;
            cursor: pointer;
        } 
        .arrowsize .half-circle {
            background-color: #dea370;
            width: 200%;
            height: 100%;
            border-radius: 50%;
            line-height: 3;
            color: #fff;
            animation: colorchange 2s infinite;
            -webkit-animation: colorchange 2s infinite;
        }
         .arrowsize .half-circle .iconfont {
            margin-left: 7px;
            display: inline-block;
            font-size: 30px;
            transform: rotate(180deg);
            -ms-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            -webkit-transform: rotate(180deg);
            -o-transform: rotate(180deg);
        }
    }
    
   
</style>